import { motion } from "framer-motion";
import { Download, Compass, Headphones } from "lucide-react";
import { useSiteLang } from "../lib/siteLang";

const icons = [Download, Compass, Headphones];

export const HowItWorks = () => {
  const { t } = useSiteLang();

  return (
    <section id="how-it-works" className="section-padding bg-[#09101F]" data-testid="how-it-works-section">
      <div className="max-w-6xl mx-auto px-5 md:px-10">
        <div className="mb-12 md:mb-16 max-w-2xl">
          <p className="section-label mb-4" data-testid="how-it-works-label">{t.howLabel}</p>
          <h2 className="text-3xl md:text-5xl text-white" style={{ textWrap: "balance" }} data-testid="how-it-works-title">
            {t.howTitle}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {t.steps.map((step, index) => {
            const Icon = icons[index];
            return (
              <motion.div
                key={step.title}
                initial={{ y: 24 }}
                whileInView={{ y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.08, ease: [0.16, 1, 0.3, 1] }}
                className="app-card inner-glow p-7"
                data-testid={`step-${index + 1}`}
              >
                <div className="flex items-center gap-4 mb-5">
                  <span className="w-11 h-11 rounded-full bg-[#00B4D8] text-white font-bold text-lg flex items-center justify-center" aria-hidden="true">
                    {index + 1}
                  </span>
                  <Icon className="w-6 h-6 text-[#FF6B00]" aria-hidden="true" />
                </div>
                <h3 className="text-xl text-white mb-2">{step.title}</h3>
                <p className="text-white/72 text-base" style={{ color: "rgba(255,255,255,0.72)" }}>{step.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
